import { messagesConstants } from '../constants';

export const messagesReducer = (state = {}, action) => {
    switch(action.type) {
        case messagesConstants.ADD_INFO_MESSAGE:
        case messagesConstants.ADD_ERROR_MESSAGE:
        case messagesConstants.ADD_SUCCESS_MESSAGE: 
            const list = state.list || [];
            return {
                ...state,
                list: [...list, action.payload]
            }

        case messagesConstants.CLEAR_ALL_MESSAGES:
            return {
                ...state,
                list: []
            }

        default:
            return state;
    }
}

export default messagesReducer;


// WEBPACK FOOTER //
// ./src/reducers/messages.js